export const betweenTimes = (time, start, end) => time > start && time < end;

export const getSunPhase = (time, pos) => {
    if (betweenTimes(time, pos.times.dawn, pos.times.sunriseEnd)) {
        return "sunrise";
    }
    if (betweenTimes(time, pos.times.sunsetStart, pos.times.dusk)) {
        return "sunset";
    }
    if (betweenTimes(time, pos.times.sunriseEnd, pos.times.sunsetStart)) {
        return "day";
    } else {
        return "night";
    }
};


// WEBPACK FOOTER //
// ./src/modules/time-stuff.js